export default (darkLightSwitch) => {
  const { localStorage } = window;
  let prefersDarkTheme = localStorage.getItem('prefersDarkColorScheme') !== null ? localStorage.getItem('prefersDarkColorScheme') === 'true' : window.matchMedia('(prefers-color-scheme: dark)').matches;
  darkLightSwitch.addEventListener('click', () => {
    darkLightSwitch.classList.toggle('on');
    let darkModeActive = darkLightSwitch.classList.contains('on');
    if (darkModeActive) {
      document.querySelector('body').classList.add('dark');
    } else {
      document.querySelector('body').classList.remove('dark');
    }
    localStorage.setItem('prefersDarkColorScheme', darkModeActive);
  });
  if (prefersDarkTheme) {
    darkLightSwitch.click();
  }
}
